export default {
  name: "Warning",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M30.14 24.5 18.6 4.5C18.06 3.56 17.08 3 16 3s-2.06.56-2.6 1.5l-11.54 20a2.98 2.98 0 0 0 0 3c.54.94 1.51 1.5 2.6 1.5h23.07c1.08 0 2.06-.56 2.6-1.5.55-.94.55-2.06.01-3zm-1.74 2c-.09.15-.34.5-.87.5H4.46c-.52 0-.78-.35-.87-.5a.976.976 0 0 1 0-1l11.54-20c.26-.45.7-.5.87-.5s.61.05.87.5l11.54 20c.25.45.08.85-.01 1zM17 11v8c0 .55-.45 1-1 1s-1-.45-1-1v-8c0-.55.45-1 1-1s1 .45 1 1zm0 12c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1z",
  },
}
